<template>
<BaseModal :id="'delete-validations'" :title="`Validations`" :size="'lg'" :message="message">
    <template v-slot:breadcrumb>
        <Breadcrumb :breadcrumb="breadcrumb" />
    </template>

    <template v-slot:content >
        <div style="margin-top: 15px" class="w-100 table-responsive defaultproject__table overflow-y--2 table-fix-head" :style="`max-height: 35rem`">
            <table class="table animate__animated animate__fadeIn animate__fast">
                <thead style="background-color: #f1f1f1">
                    <tr>
                        <th style="font-weight: normal !important" class="header-item-manual" v-for="(item, i) in summary_table_headers" :key="i" scope="col" v-html="item.name" />
                    </tr>
                </thead>
                <tbody class="">
                    <template>
                        <tr v-for="(item, i) in validate_data" :key="i">
                            <td v-html="`${i + 1}`" />
                            <td v-html="item.floor" />
                            <td v-html="item.room_counter" />
                            <td v-html="item.room_type_counter" />
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <CentralLiteButtons :save_text="'Done'" />
    </template>
</BaseModal>
</template>

  
  
<script>
import Breadcrumb from "@/components/BreadcrumbComponent/Breadcrumb";
import CentralLiteButtons from '@/components/CentralLiteButtons'
import BaseModal from "@/components/BaseModal";

export default {
    name: "DeleteValidationsModal",

    props: ["breadcrumb", "validate_data"],

    components: {
        BaseModal,
        Breadcrumb,
        CentralLiteButtons
    },

    data() {
        return {
            summary_table_headers: [{
                    name: "#",
                },
                {
                    name: "Floor Type",
                },
                {
                    name: "Room Counter",
                },
                {
                    name: "Room Type Counter",
                },
            ],
            breadcrumb_local: [],
            message: `The following floor types were not deleted because they have rooms and/or room types associated with them.`,
            select_all: true,
        };
    },

    methods: {
        close(event) {
            this.$emit("close", event);
        },
    },

    computed: {},

    mounted() {
        // let breadcrumb_local = JSON.parse(JSON.stringify(this.breadcrumb))
        // breadcrumb_local =[this.breadcrumb.length - 1].arrow =
        //     "<span class='slash'>/</span>";
        // breadcrumb_local.push({
        //     name: "Validation Modal",
        //     arrow: "",
        // });

        // this.breadcrumb_local = breadcrumb_local
    },
};
</script>
